<template>
  <div class="image-gen-view">
    <SingleColorGen v-if="workbench.imageGen.step === 2" @fission="onStepChange" />
    <MultiColorFission v-else-if="workbench.imageGen.step === 3" @back="workbench.imageGen.step = 2" />
    <MainImageGen v-else-if="workbench.imageGen.step === 4" @back="workbench.imageGen.step = 3" />

    <div v-if="workbench.lightbox.show" class="lightbox" @click="workbench.closeLightbox">
      <div class="lightbox-body" @click.stop>
        <img :src="workbench.lightbox.url" alt="preview" />
        <button v-if="workbench.lightbox.index > 0" class="lightbox-arrow lightbox-prev" @click.stop="workbench.lightboxPrev">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="28" height="28"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button v-if="workbench.lightbox.index < workbench.lightbox.images.length - 1" class="lightbox-arrow lightbox-next" @click.stop="workbench.lightboxNext">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="28" height="28"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
      <button class="lightbox-close" @click.stop="workbench.closeLightbox">&times;</button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import SingleColorGen from '@/components/image-gen/SingleColorGen.vue'
import MultiColorFission from '@/components/image-gen/MultiColorFission.vue'
import MainImageGen from '@/components/image-gen/MainImageGen.vue'

const workbench = useWorkbenchStore()

const onStepChange = () => {
  // Step is already set by the store
}

const handleKeydown = (e) => {
  if (!workbench.lightbox.show) return
  if (e.key === 'Escape') {
    workbench.closeLightbox()
  } else if (e.key === 'ArrowLeft') {
    workbench.lightboxPrev()
  } else if (e.key === 'ArrowRight') {
    workbench.lightboxNext()
  }
}

onMounted(() => document.addEventListener('keydown', handleKeydown))
onUnmounted(() => document.removeEventListener('keydown', handleKeydown))
</script>
